import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CustomerAuthAPI } from '../../Services/ECommerceAPI';
import { toast } from 'react-toastify';
import './CustomerAuth.css';

const CustomerLogin = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await CustomerAuthAPI.login(formData.email, formData.password);
            
            if (response.token) {
                sessionStorage.setItem('token', response.token);
                sessionStorage.setItem('user', JSON.stringify(response.user));
                toast.success('Login successful!');
                navigate('/shop');
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error(error.response?.data || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Customer Login</h2>
                <p className="auth-subtitle">Sign in to your account</p>
                
                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="Enter your email"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            placeholder="Enter your password"
                        />
                    </div>
                    
                    <button type="submit" className="auth-button" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
                
                <div className="auth-footer">
                    <p>Don't have an account? <Link to="/customer/register">Sign up here</Link></p>
                    <p><Link to="/shop">Continue shopping as guest</Link></p>
                </div>
            </div>
        </div>
    );
};

export default CustomerLogin;
